import Vue from 'vue';
import VueI18n from 'vue-i18n';

// https://github.com/kazupon/vue-i18n/issues/474#issuecomment-444817451
import {languages} from './translations/index.js';
const messages = Object.assign(languages);

Vue.use(VueI18n);

// Locale is taken from what the browser is using, but we allow
// overriding this in the User Account page. That override would then
// be stored in localStorage and remembered across browser sessions.
export function getInitialBrowserLocale() {
  const browserlanguage = navigator.language || navigator.userLanguage;
  let initialLocale = browserlanguage.startsWith('de') ? 'de' : 'en';
  if (window.Cypress) {
    initialLocale = 'de';
  }
  return initialLocale;
}

// Setup localization.
const i18n = new VueI18n({
  locale: getInitialBrowserLocale(),
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js